import { render } from "./Setting.vue?vue&type=template&id=dd7c2dc0&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=dd7c2dc0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dd7c2dc0"

export default script